import type { ButtonConfig } from '../../declare'

type Props = {
  config: ButtonConfig
}

const MultiPageBtn = (props: Props) => {
  return <div>MultiPageBtn</div>
}

export default MultiPageBtn